import { Authenticate3DSError } from '@/model/Authenticate3DSError';
import { Authenticate3DSRequest } from '@/model/Authenticate3DSRequest';
import { Authenticate3DSResponse } from '@/model/Authenticate3DSResponse';

export enum ShowModalPayment {
  CONFIRM_DELETE_CREDIT_CARD_PAYMENT = 'confirm_delete_credit_card_payment',
  CREDIT_CARD_PAYMENT = 'credit_card_payment',
  TICKET_PAYMENT = 'ticket_payment',
  PIX_PAYMENT = 'pix_payment',
  PAYMENT_ERROR = 'payment_error',
  PAYMENT_NOTMADE = 'payment_notmade',
  NO_CARD = 'no_card',
}

export enum FromFractionalPayment {
  paidAmount = 'paidAmount',
}

export interface CardCheckout {
  cardSelectedInt: number;
  selected: boolean;
  id: string;
  number: string;
  numberError: string;
  expDate: string;
  expDateError: string;
  securityCodeDb: string;
  securityCode: string;
  securityCodeError: string;
  holder: string;
  holderError: string;
  document: string;
  documentError: string;
  value: string;
  valueWithFee: number;
  valueError: string;
  installments: number;
  installmentsError: string;
  validationValue: string;
  validationValueError: string;
  validated: boolean;
}

export type ShouldShowModalProps = {
  value: ShowModalPayment;
  newTitle: string | React.ReactNode;
};

export enum Auth3DSStatus {
  NONE = 'NONE',
  START = 'START',
  AUTH_SUCCESS = 'AUTH_SUCCESS',
  AUTH_ERROR = 'AUTH_ERROR',
}

export interface Auth3DSResponse {
  cardId: string;
  session: string;
  installments: number;
  paymentOriginalValue: number;
  paymentValue: number;
  paymentFee: number;
  request: Authenticate3DSRequest;
  response?: Authenticate3DSResponse;
  error?: Authenticate3DSError;
}
